import { alpha, styled } from "@mui/material";

export const StyledLocationItem = styled('div')<{ active: boolean }>(({ theme, active }) => ({
	padding: '16px 8px',
	borderRadius: 4,
	border: `solid 1px ${theme.palette.borders.primary}`,
	display: 'flex',
	justifyContent: 'center',
	cursor: 'pointer',
	...(active && {
		border: `solid 1px ${theme.palette.secondary.main}`,
		background: alpha(theme.palette.secondary.main, 0.1),
		cursor: 'default',
	})
}))

export const StyledLocationName = styled('span')({
	fontSize: 14,
	textAlign: 'center'
})

export const StyledCenteredDiv = styled('div')(({ theme }) => ({
	fontWeight: theme.typography.fontWeightMedium,
	display: 'flex',
	justifyContent: 'center'
}))

export const StyledSelectLocation = styled('div')({
	display: 'flex',
	justifyContent: 'center',
	fontSize: 12
})

export const StyledLocationsWrapper = styled('div')({
	display: 'grid',
	rowGap: 8
})
